<template>
  <div class="dashboard">
    <div class="row">
      <div class="flex xs12 lg12">
        <AccountList />
      </div>
    </div>
    <div class="row">
      <div class="flex xs12 lg12">
        <account-details />
      </div>
    </div>
  </div>
</template>

<script>
import AccountList from './AccountList'
import AccountDetails from './AccountDetails'
export default {
  name: 'alerts',
  components: {
    AccountList,
    AccountDetails,
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss">
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}
.dashboard {
  .va-card {
    margin-bottom: 0 !important;
  }
}
</style>
